import { ASThemeProvider } from '@eleventheye/asui';
import { nflStatsTheme } from 'theme/nflStatsTheme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import router from 'routes/Router';
import { persistor, store } from './app/store';
import './index.scss';

// Initialize debug interface in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/DebugInterface');
}

const container: HTMLElement | null = document.getElementById('root');

if (container === null) {
  throw Error('root not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ASThemeProvider theme={nflStatsTheme}>
          <RouterProvider router={router}></RouterProvider>
        </ASThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
